// hooks/useTypo.ts
import { useEffect, useState } from 'react';
import Typo from 'typo-js';

// 全局缓存
const typoCache = new Map<string, Typo>();

export function useTypo(locale: string = 'en_US') {
    const [typo, setTypo] = useState<Typo | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        async function loadDictionary() {
            // 如果已有缓存，直接用
            if (typoCache.has(locale)) {
                setTypo(typoCache.get(locale)!);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);

                const affUrl = `https://public.static.meitudata.com/xiuxiu-pc/x-design/designer/${locale}.aff`;
                const dicUrl = `https://public.static.meitudata.com/xiuxiu-pc/x-design/designer/${locale}.dic`;

                const [affRes, dicRes] = await Promise.all([fetch(affUrl), fetch(dicUrl)]);

                const [affData, dicData] = await Promise.all([affRes.text(), dicRes.text()]);

                const dictionary = new Typo(locale, affData, dicData, {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    platform: 'any',
                });

                // 缓存实例
                typoCache.set(locale, dictionary);
                setTypo(dictionary);
            } catch (err) {
                setError(err as Error);
            } finally {
                setLoading(false);
            }
        }

        loadDictionary();
    }, [locale]);

    const check = (word: string): boolean => {
        return typo?.check(word) ?? false;
    };

    const suggest = (word: string): string[] => {
        return typo?.suggest(word) ?? [];
    };

    return { typo, check, suggest, loading, error };
}
